import { JottaFooter } from '../JottaFooter/JottaFooter'
import { PublicFooter } from '../PublicFooter/PublicFooter'
import { useBrandCode } from '../../hooks/useBrandTheme'

export function Footer() {
  return useBrandCode() === 'JOTTACLOUD' ? <JottaFooter /> : <PublicFooter />
}
